<template>
  <div class="app-container emoti-page hide-product">
    <emoti-page-header
      ref="pageHeader"
      :customMenus="customPageHeaderMenus"
      :customHomeMenu="customHomeMenu"
      @clickMenu="handleSelectHeaderMenu"
      @logout="logout"
      :wikiView="false"
    ></emoti-page-header>
    <emoti-product-menu
      :productMenuList="enterpriseID ? privProducts : []"
      :key="2"
      :currentModule="currentModule"
      ref="emotiProductMenu"
    ></emoti-product-menu>
    <router-view class="app-body emoti-container" :class="{'app-body-toggle':menuFold,}" />
    <pop-windows></pop-windows>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import misc from '@/utils/js/misc';
import systemAPI from '@/api/system';
import authAPI from '@/api/auth';
import loginAPI from '@/api/login';
import enterpriseAPI from '@/manage-modules/SystemManage/_api/enterprise';
import licenseAPI from '@/manage-modules/License/_api/license';

export default {
  api: [systemAPI, authAPI, enterpriseAPI, licenseAPI, loginAPI],
  data() {
    return {
      msg: 'msg',
      robotName: 'robotName',
      customHomeMenu: {
        title: this.$t('privileges.modules.management'),
        isRouter: true,
        toModule: '',
        toRoute: '',
        icon: 'header_robot_list',
        key: 'auth-home',
      },
      // customPageHeaderMenus: {
      //   right: [
      //     {
      //       key: 'service-warning',
      //       title: this.$t('generl.chat_test'),
      //       icon: 'icon-fuwujiankong1',
      //       isRouter: true,
      //       toModule: 'devops',
      //       toRoute: 'dashboard',
      //       openNewTab: true,
      //     },
      //   ],
      // },
      currentModule: 'auth',
      toggleType: 'product',
      menuFold: false,
      // service warning
      warning: false,
    };
  },
  watch: {
    warning(val) {
      if (val) {
        document.querySelector('.icon-fuwujiankong1').classList.add('warning');
      }
    },
  },
  created() {
    // 获取userInfo & request token 初始值 - 登陆接口获取值
    // 获取products & enterpriseInfoList 存储值
    console.log('aaa');
    this.initDataFromLocalStorage();
    this.$nextTick(() => {
      this.initializeData();
    });
    this.$root.$on('navigateToProduct', this.navigateToDetailWhenOrgChange);
  },
  computed: {
    ...mapGetters([
      'USER_TYPES',
      'userType',
      'userID',
      'orgID',
      'enterpriseID',
      'privProducts',
      'allProducts',
    ]),
    customPageHeaderMenus() {
      return {
        left: [],
        right: [
          {
            key: 'chat-test',
            title: '',
            icon: 'icon-chat-test-01',
            isRouter: false,
          },
          {
            key: 'service-warning',
            title: this.$t('general.chat_test'),
            icon: 'icon-fuwujiankong1',
            isRouter: true,
            toModule: 'devops',
            toRoute: 'dashboard',
            openNewTab: true,
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      'updateAllProducts',
      'updatePriviProductIDs',
    ]),
    ...mapMutations([
      'setLicenseInfo',
      'setUserInfo',
      'setEnterpriseId',
      'setEnterpriseInfoList',
      'setOrgList',
      'setOrgId',
      'setPriviProducts',
      'setLanguage',
    ]),
    // 初始化数据
    initializeData() {
      console.log('AUTH UI - initializeData');
      // 设置浏览器标签标题
      this.initializeBrowserTitle();
      this.initializeLogos();
      this.getLicenseExpireInfo().then(() => {
        this.fetchAllProductsByUserId(this.userID);
        this.fetchEnterpriseInfoList(this.userType, this.enterpriseID);
      }).then(() => {
        this.handleNavigation();
        if (this.$refs.pageHeader) {
          this.$refs.pageHeader.initializeData();
        }
        // this.handleGetAllServiceStatus();
      });
    },
    async logout() {
      const SSOEnable = process.env.SSO_ENABLE;
      if (SSOEnable) {
        await this.$api.logout();
      }
    },

    handleGetAllServiceStatus() {
      this.$api.getAllServiceStatus()
      .then((res) => {
        // eslint-disable-next-line
        res.status === 'ERROR' ? this.warning = true : this.warning = false;
      })
      .finally(() => {
        setTimeout(() => {
          this.handleGetAllServiceStatus();
        }, 300000);
      });
    },
    handleNavigation() {
      const currentRoute = window.location.hash.substring(1);
      // 系统管理页面
      const validSystemManageRoutes = [
        // 个人资料
        '/manage/user-preference',
        // 许可证管理
        '/manage/license',
        // 系统管理页面
        '/manage/enterprise-manage',
        '/manage/system-admin-list',
        '/manage/system-setting',
        // 操作记录页面
        '/manage/audit-system',
        '/manage/audit-enterprise',
        '/manage/audit-robot',
      ];
      const validEntManageRoutes = [
        // '/',
        // 个人资料页面
        '/manage/user-preference',
        // 权限管理页面
        '/manage/organization-list',
        '/manage/enterprise-role-list',
        '/manage/enterprise-user-list',
        '/manage/enterprise-setting',
        // 操作记录页面
        '/manage/audit-enterprise',
        '/manage/audit-robot',
      ];
      const validUesrManageRoutes = [
        '/manage/user-preference',
        '/manage/audit-robot',
        '/manage/audit-enterprise',
      ];
      if (this.userType === this.USER_TYPES.SUPER_MANAGER) {
        // 初始登陆后，或点击Home按钮，会打开'/'
        if (currentRoute === '/') {
          this.$router.push('/manage/enterprise-manage');
        } else if (this.enterpriseID) {
          // 超管 - 跳转到企业管理页面
          if (validSystemManageRoutes.indexOf(currentRoute) !== -1
          || validEntManageRoutes.indexOf(currentRoute) !== -1) {
            console.log('to system manage or enterprise manage');
          } else {
            this.setOrSelectOrgId();
          }
        } else if (validSystemManageRoutes.indexOf(currentRoute) !== -1) {
          console.log('to system manage page');
        } else {
          this.$router.push('/manage/enterprise-manage');
        }
      // } else if (!(validEntManageRoutes.indexOf(currentRoute) !== -1
      // && this.userType === this.USER_TYPES.ENTERPRISE_MANAGER)) {
      } else if (this.userType === this.USER_TYPES.ENTERPRISE_MANAGER) {
        // 企业管理员
        if (validEntManageRoutes.indexOf(currentRoute) !== -1) {
          console.log('to enterprise manage pages');
        } else {
          this.setOrSelectOrgId();
        }
      } else {
        // 普通用户
        if (validUesrManageRoutes.indexOf(currentRoute) !== -1) {
          console.log('to user manage pages');
          return;
        }
        this.setOrSelectOrgId();
      }
    },
    setOrSelectOrgId() {
      // 普通账户
      this.$api.getSelectOrg(this.userID).then((orgList) => {
        this.setOrgList(orgList || []);
        // watch OrgId发生变化时，路由会推送到第一个产品的内部页面
        if (orgList && orgList.length === 1) {
          this.setOrgId(orgList[0].orgid);
          this.$root.$emit('navigateToProduct');
        } else {
          this.$router.push('/manage/select-org');
        }
      }).catch(() => {
        this.$message({
          message: this.$t('messages.license_fail_message'),
          type: 'error',
        });
      });
    },
    navigateToDetailWhenOrgChange() {
      if (!this.orgID && this.orgID !== 0) {
        this.$message.error(this.$t('messages.no_selected_org'));
        return;
      }
      this.fetchPriviProdIDsByOrgId(this.orgID).then(() => {
        if (this.privProducts && this.privProducts.length) {
          window.location = `/${this.privProducts[0].toModule}.html`;
        } else {
          this.$message.warning(this.$t('messages.no_product_msg'));
        }
      });
    },
    getLicenseExpireInfo() {
      return this.$api.getLicenseInfo().then((res) => {
        if (res.status >= 0) {
          this.setLicenseInfo(res.result);
          const ret = res.result || {};
          const showNotice = (ret.license_exist && ret.license_expired)
            || (!ret.license_exist && !ret.license_Probation);
          if (showNotice) {
            const message = (ret.license_exist && ret.license_expired)
            ? this.$t('general.license_expired') : this.$t('general.license_probation_expired');
            this.$message({
              message,
              type: 'error',
              duration: 0,
            });
          }
        }
      }).catch(() => {
        this.$message({
          message: this.$t('messages.org_fail_message'),
          type: 'error',
        });
      });
    },
    fetchEnterpriseInfoList(userType, enterpriseId) {
      if (userType === this.USER_TYPES.SUPER_MANAGER) {
        this.$api.getEnterprises().then((res) => {
          console.log(res);
          if (res && res instanceof Array) {
            this.setEnterpriseInfoList(res);
          } else if (typeof res === 'object') {
            this.setEnterpriseInfoList([res]);
          }
        });
      } else {
        this.$api.getEnterpriseInfo(enterpriseId).then((res) => {
          console.log(res);
          if (res && res instanceof Array) {
            this.setEnterpriseInfoList(res);
          } else if (typeof res === 'object') {
            this.setEnterpriseInfoList([res]);
          }
        });
      }
    },
    fetchAllProductsByUserId(userID) {
      this.$api.fetchProducts(userID)
      .then((res) => {
        if (res.result && res.result instanceof Array) {
          let data = [];
          data = res.result.map(v => ({
            ...v,
            toModule: v.code,
            toRoute: v.route,
            name: v.name,
            icon: v.icon,
          }));
          this.updateAllProducts(data || []);
        } else {
          this.updateAllProducts([]);
        }
      })
      .catch(() => {
        this.$message({
          message: this.$t('messages.product_fail_message'),
          type: 'error',
        });
      });
    },
    fetchPriviProdIDsByOrgId(orgId) {
      return this.$api.getProductIDsByOrg(orgId)
      .then((res) => {
        this.updatePriviProductIDs(res || []);
      })
      .catch(() => {
        this.$message({
          message: this.$t('messages.product_fail_message'),
          type: 'error',
        });
      });
    },
    // 初始化浏览器标签页标题
    initializeBrowserTitle() {
      misc.setPageTitle(this.$t('general.system_name_default'));
    },
    // 初始化浏览器图标
    initializeLogos() {
      // 浏览器标签页图标
      this.$api.getIcon('favicon', this.enterpriseID)
      .then(() => {
        // 企业管理员设置的图标
        misc.changeFavicon(this.$api.getIconURL('favicon', this.enterpriseID));
      })
      .catch(() => {
        this.$api.getIcon('favicon')
        .then(() => {
          // 系统管理员设置的图标
          misc.changeFavicon(this.$api.getIconURL('favicon'));
        })
        .catch(() => {
          misc.changeFavicon('/public/images/favicon.png');
        });
      });
      // 产品栏左上角图标
      this.$api.getIcon('app', this.enterpriseID)
        .then(() => {
          this.$refs.emotiProductMenu.enterprisePic = this.$api.getIconURL('app', this.enterpriseID);
        })
        .catch(() => {
          this.$api.getIcon('app')
          .then(() => {
            this.$refs.emotiProductMenu.enterprisePic = this.$api.getIconURL('app');
          })
          .catch(() => {
            this.$refs.emotiProductMenu.enterprisePic = 'default';
          });
        });
    },
    initDataFromLocalStorage() {
      try {
        // 设置请求的header - token
        this.$setReqToken(window.localStorage.getItem('token'));
        // 设置用户信息
        const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        if (userInfo && userInfo.id) {
          this.setUserInfo(userInfo);
        }
        if (userInfo.enterprise) {
          this.setEnterpriseId(userInfo.enterprise);
        }
        const enterpriseId = window.localStorage.getItem('enterprise');
        if (enterpriseId) {
          this.setEnterpriseId(enterpriseId);
        }
        // 设置产品列表参数
        const products = JSON.parse(window.localStorage.getItem('products'));
        if (products && products.length) {
          this.setPriviProducts(products);
        }
        // 设置企业信息列表
        const enterpriseInfoList = JSON.parse(window.localStorage.getItem('enterpriseInfo'));
        if (enterpriseInfoList && enterpriseInfoList.length) {
          this.setEnterpriseInfoList(enterpriseInfoList);
        }
        // 设置多语言
        const locale = window.localStorage.getItem('locale');
        if (locale) {
          this.setLanguage(locale);
        }
        // 设置组织id
        const orgId = window.localStorage.getItem('orgId');
        if (orgId) {
          this.setOrgId(orgId);
          this.$root.$emit('navigateToProduct');
        }
      } catch (_) {
        console.log('no product list in local storage');
      }
    },
    handleSelectHeaderMenu(key) {
      if (key === 'auth-home') {
        this.handleNavigation();
      }
    },
  },
};
</script>
<style lang="scss">
.app-body-toggle {
  .nav-bar {
    top: 0px;
  }
}
</style>
<style lang="scss" scoped>
.app-container {
  .app-body {
    position: absolute;
    left: 60px;
    top: 50px;
    width: calc(100vw - 60px);
    height: calc(100vh);
    background: #eeeeee;
  }
  .app-body-toggle {
    left: 0;
    width: 100%;
  }
}
.page-header {
  /deep/ .icon-fuwujiankong1.warning {
    color: #f25c5c !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue